<template>
  <div class="flex-page">
    <template v-if="detail.studentName">
      <div class="main">
        <vx-list
          style="height: 100%"
          :api="api"
          :params="params"
          :enableAutoScrollTop="false"
          @load="onload"
          ref="vxlist"
        >
          <div class="b1">
            <div class="base van-hairline--bottom">
              <div class="base-l">{{ detail.studentName.slice(-2) }}</div>
              <div class="base-r">
                <div>
                  {{ detail.studentName }}&nbsp;<span class="desc"
                    >
                    <!-- 的{{ detail.commentType == 0 ? "课堂" : "个人" }}表现 -->
                    </span
                  >
                </div>
                <div class="time">
                  {{ detail.createTime | formatDatetime('yyyy年MM月dd日')}}
                </div>
              </div>
            </div>
            <div class="class-info">
              <div class="class-info-item" v-if="detail.commentType == 0">
                {{ detail.className }}&nbsp;{{
                  detail.classTime.date | formatDatetime(new Date(detail.classTime.date).getFullYear()===new Date().getFullYear()?'MM月dd日':'yyyy年MM月dd日')
                }}({{ detail.classTime.weekdayName }})&nbsp;{{
                  detail.classTime.startTime
                }}～{{ detail.classTime.endTime }}
              </div>
              <div class="class-info-item">
                点评人：{{ detail.commentKeeperName }}
              </div>
              <div class="class-info-item" v-if="detail.commentType == 0">
                评分：<van-rate
                  v-model="detail.score"
                  void-icon="star"
                  size="var(--fs-md)"
                  void-color="var(--g4)"
                  color="var(--c4)"
                  :readonly="true"
                />
              </div>
            </div>
            <div class="comment-title">
              {{ detail.commentTitle }}
          </div>
            <vx-mult-input-show
              :list="detail.commentContent.list"
            ></vx-mult-input-show>
          </div>

          <!-- 点评状态：若视频还在合成，则：1、隐藏底部点评模块 contentGlobalStatus：1 合成中 2已合成 3合成失败（含失败的会优先合成失败） -->
          <template v-if="detail.contentGlobalStatus == 2">
            <card v-if="showQanda" 
              app="teacher" 
              :isEdit="false"
              :params="qandaParams"/>     
  
            <div class="b2">
              <!-- 回复部分 -->
              <div class="til">
                <div class="t1">全部回复</div>
                <div class="t2">（{{ allReplyNum }}）</div>
              </div>
  
              <template v-if="replyList.length > 0">
                <div
                  class="reply"
                  v-for="(item) in replyList"
                  :key="item.id"
                >
                  <!-- <div class="pho"></div> -->
                  <img class="pho" :src="item.replyPhoto.url" alt="" />
                  <div class="info">
                    <div class="l1">
                      <div class="l1l">{{ item.replyName }}</div>
                    </div>
                    <div class="l2">
                      {{ item.createTime | formatGoodDate() }}
                    </div>
                    <div class="l3">
                      <template v-if="true">
                        <span>回复 </span>
                        <span class="l31">{{ item.repliedName }}：</span>
                      </template>
                      <span> {{ item.replyContent.list[0].content }}</span>
                    </div>
                  </div>
                </div>
              </template>
  
              <van-empty
                v-else
                image="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png"
                image-size="128"
                style="padding: 16px 0"
                description="暂无回复～"
              >
              </van-empty>
            </div>
          </template>
        </vx-list>
      </div>
    </template>
  </div>
</template>

<script>
import card from '@teacher/views/base/comment/course-comment/children/qanda-card.vue';

export default {
  name: "comment-detail",
  components:{
    card,
  },
  data() {
    return {
      commentId: "",
      companyId: "",
      detail: {},
      // 回复列表
      replyList: [],
      allReplyNum: 0,
      api: this.$api.getCommentReplyRecordPage,
      params: {
        commentRecordId: this.$route.params.id,
        companyId: this.$route.params.cid,
      },
      qandaParams:{},
      shareParams: {},
    };
  },
  computed: {
    showQanda(){
      return this.detail && (this.detail.reviewEnable == 1) && (this.detail.reviewStatus == 2) && (this.detail.commentSet.showFromTeacher == 1);
    }
  },
  methods: {
    onload(list, res) {
      this.replyList = list;
      this.allReplyNum = res.page.totalCount;
    },
    render() {
      this.showLoading();
      this.$api
        .getCommentDetail({
          commentId: this.commentId,
          companyId: this.companyId,
        })
        .then((res) => {          
          this.$toast.clear();
          if (res.code === 200) {
            if (res.data.reviewEnable){
              this.qandaParams = {
                answerId: res.data.reviewQandaAnswerId,
                companyId: this.companyId,
                answerApi : this.$api.answerInfo,
              }
            }
            this.detail = res.data;
          } else {
            this.$toast.fail(res.msg);
          }
        });
    },
  },
  created() {
    this.commentId = this.$route.params.id;
    this.companyId = this.$route.params.cid;
    this.render();
  },
};
</script>

<style lang="scss" scoped>
.flex-page {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.main {
  flex: 1;
}
.b1 {
  padding: 0 16px 16px 16px;
  background-color: var(--white);
  .base {
    padding: calc(var(--gap) * 16) 0;
    display: flex;
    .base-l {
      display: inline-block;
      width: calc(var(--w) * 40);
      height: calc(var(--w) * 40);
      line-height: calc(var(--w) * 40);
      border-radius: 50%;
      background-color: var(--c1);
      color: var(--white);
      text-align: center;
      vertical-align: middle;
      margin-right: calc(var(--gap) * 8);
    }
    .base-r {
      flex: 1;
      position: relative;
      .desc {
        color: var(--g6);
      }
      .time {
        margin-top: calc(var(--gap) * 2);
        font-size: var(--fs-sm);
        line-height: var(--lh-sm);
        color: var(--g6);
      }
    }
  }
  .class-info {
    padding-bottom: calc(var(--gap) * 12);
    color: var(--g6);
    .class-info-item {
      padding-top: calc(var(--gap) * 12);
      .van-rate {
        vertical-align: middle;
      }
    }
  }
  .comment-title{
    font-size:16px;
    font-weight:600;
    margin-top:8px;
    margin-bottom:10px;
  }
}

.b2 {
  margin-top: calc(var(--gap) * 12);
  background-color: var(--white);
  padding: 0 calc(var(--gap) * 16);
  .til {
    display: flex;
    align-items: center;
    padding: calc(var(--gap) * 16) 0;
    .t1 {
      font-size: var(--fs-lg);
      // line-height: var(--lh-lg);
      font-weight: bold;
    }
    .t2 {
      font-size: var(--fs-sm);
      // line-height: var(--lh-sm);
      font-weight: normal;
    }
  }
  .reply {
    display: flex;
    padding-bottom: calc(var(--gap) * 24);
    .pho {
      margin-top: calc(var(--gap) * 4);
      margin-right: calc(var(--gap) * 8);
      width: calc(var(--w) * 40);
      height: calc(var(--w) * 40);
      border-radius: calc(var(--w) * 40);
      background: #000;
    }
    .info {
      flex: 1;
      .l1 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .l1l {
          color: var(--g7);
          font-size: var(--fs-md);
          line-height: var(--lh-md);
        }
        .l1r {
          padding: calc(var(--gap) * 4);
        }
        .r1 {
          color: var(--g8);
        }
        .r2 {
          color: var(--c3);
        }
        .icon {
          margin-right: calc(var(--gap) * 2);
        }
      }
      .l2 {
        color: var(--g6);
        font-size: var(--fs-sm);
        line-height: var(--lh-sm);
      }
      .l3 {
        padding-top: calc(var(--gap) * 8);
        font-size: var(--fs-lg);
        line-height: var(--lh-lg);
        color: var(--g8);
        white-space:normal; 
        word-break:break-all;
        .l31 {
          color: var(--g6);
        }
      }
    }
  }
}
</style>